import Vue from 'vue';
import App from './App.vue';
import CapitalUI from '@capital-platforms/cpui';
import router from './router';
import store from './store';
import './registerServiceWorker';

import helperFunctions from '@/utils/helperFunctions';
import FloatingVue from 'floating-vue';
import axios, { AxiosError } from 'axios';
import { startAuthTabSync } from '@/utils/hydrate-auth-session';

Vue.use(CapitalUI);
Vue.use(helperFunctions);
Vue.use(FloatingVue, {
  themes: {
    'info-tooltip': {
      $extend: 'tooltip',
      $resetCss: true,
    },
  },
});

// Sentry modules
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

import {
  CPTextInput,
  CPCheckbox,
  CPButton,
  CPCollapsible,
} from '@capital-platforms/cpui';
import '@/logger/logging-token';

import logger from '@/logger/logging-tab';
import { ENVIRONMENT } from './config';

startAuthTabSync();

axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    const url = String(error.config?.url ?? '').toLowerCase();
    const isAuthRequest =
      url.includes('authenticate') || url.includes('/login');

    if (status === 401 && !isAuthRequest && store.state.account.token) {
      store.dispatch(
        'addError',
        'Sorry you have been logged out due to inactivity or timeout, please login again',
      );
      store.dispatch('logout', { broadcast: true });
    }

    return Promise.reject(error);
  },
);
Vue.component('CPTextInput', CPTextInput);
Vue.component('CPCheckbox', CPCheckbox);
Vue.component('CPButton', CPButton);
Vue.component('CPCollapsible', CPCollapsible);

// Sentry.init({
//   dsn: process.env.VUE_APP_SENTRY_DSN,
//   environment: process.env.VUE_APP_SENTRY_ENV,
//   integrations: [
//     new Integrations.BrowserTracing(),
//     new VueIntegration({
//       Vue,
//       attachProps: true,
//       tracingOptions: {
//         trackComponents: true,
//       },
//     }),
//   ],
// });
if (ENVIRONMENT === 'production') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENV,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'my-site-url.com', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

window.onpagehide = () => logger.loggingCloseTab();

console.log(process.env.VUE_APP_SENTRY_DSN, process.env.VUE_APP_SENTRY_ENV);

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
